import { Observable } from 'rxjs';
import { Message } from 'primeng/api';

export interface MessageProvider {
  messageObserver: Observable<Message | Message[]>;
  clearObserver: Observable<string>;
  add: (message: Message) => void;
  addAll: (messages: Message[]) => void;
  clear: (key?: string) => void;
}
